import { PageDoesntExist } from "@/pageDoesntExist";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import { siteRoutes } from "../siteRoutesList";
import { Challenge1337PageReset } from "branchAndBrandSpecific/features/1337-challenge/1337.challenge.page.reset";
import PrecisionGame from "@/pages/PrecisionGame/PrecisionGame";

export const precisionGameRoutes = [
  {
    element: brand.hasFeature.precisionGame
      ? Challenge1337PageReset
      : PageDoesntExist,
    path: siteRoutes["leet-reset-trigger"],
  },
  {
    element: brand.hasFeature.precisionGame ? PrecisionGame : PageDoesntExist,
    path: siteRoutes["leet"],
  },
];
